import config from "../../app.json";
import axios from "axios";

import "./newchatlist.scss";
import React, { useState, useEffect, useContext } from "react";
import FieldText from "../Fields/FieldText";
import FieldSelect from "../Fields/FieldSelect";
import ModalComponent from "../ModalComponent";
import AlertComponent from "../AlertComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faSquare } from "@fortawesome/free-solid-svg-icons";
import { Context } from "../../Reducers/Store";

import UserAvatar from "../../Assets/Images/avatar-sc.png";
import Image from "../Image/image";
import { Button } from "react-bootstrap";
import PlusIcon from "../../Assets/Images/plus.svg";

function NewChatlist(props) {
  const [state, dispatch] = useContext(Context);

  const [currentUser, setCurrentUser] = useState(null);
  const [chatName, setChatName] = useState(null);
  const [selectedColor, setSelectedColor] = useState(0);
  const [colorOptionId, setColorOption] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [membersOptions, setMembersOptions] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [allMembersOptions, setAllMembersOptions] = useState([]);
  const [selectedPermission, setSelectedPermission] = useState({ value: "Reader", label: "Can View" });

  useEffect(() => {
    if (!props.currentChatId || props.currentChatId < 0) {
      setChatName(null);
      setSelectedColor(0);
      setColorOption(null);
      setSelectedUser(null);
      setMembersOptions([]);
      setSelectedMembers([]);
      setAllMembersOptions([]);
    }
  }, [0]);

  useEffect(() => {
    if (colorOptionId) {
      setSelectedColor(colorOptionId.value);
    }
  }, [colorOptionId]);

  useEffect(() => {
    if (state?.isLogged && props.currentChatId > 0) {
      const allOptions = [...options, { value: "Creator", label: "Creator" }];
      setSelectedMembers([]);
      axios
        .get(config.API_HM + "/chatlists/" + props.currentChatId)
        .then((result) => {
          const data = result.data;

          const uniqueUsers = data.members.filter((color, index, self) => index === self.findIndex((c) => c.userId === color.userId));

          const currentMembers = uniqueUsers.map((item) => {
            const optPermissionSelected = allOptions.find((colorOption) => colorOption.value === item.permission);

            const memberFromList = allMembersOptions.filter((x) => x.userId === item.userId);
            const name = memberFromList.at(0)?.name;

            return {
              userId: item.userId,
              name: name,
              permissionSelected: optPermissionSelected,
              permission: optPermissionSelected.value,
            };
          });

          setSelectedMembers(currentMembers);

          const colorIndex = possibleColorOptions.findIndex((colorOption) => colorOption.value === data.color);
          if (colorIndex != -1) {
            setColorOption(possibleColorOptions[colorIndex]);
          }
          setChatName(data.name);
          setSelectedColor(data.color);
        })
        .catch((error) => {
          AlertComponent("Error", error.message ?? "Something went wrong. ChatList info could not be loaded. Code: 1", { icon: `error` });
        });
    } else {
      setChatName(null);
      setSelectedColor(0);
      setColorOption(null);
      setSelectedUser(null);
      setMembersOptions([]);
      if (currentUser) {
        setSelectedMembers([{ userId: currentUser.id, permission: "Creator", name: currentUser.name, permissionSelected: { label: "Creator", value: "Creator" } }]);
      } else {
        setSelectedMembers([]);
      }
    }
  }, [allMembersOptions, props.currentChatId]);

  useEffect(() => {
    if (currentUser) {
      setSelectedMembers([{ userId: currentUser.id, permission: "Creator", name: currentUser.name, permissionSelected: { label: "Creator", value: "Creator" } }]);
    }
  }, [currentUser]);

  useEffect(() => {
    if (state?.isLogged) {
      dispatch({ type: "SET_LOADING", payload: true });
      
      axios
        .get(config.API_HM + "/profile")
        .then((result) => {
          setCurrentUser(result.data);
        })
        .catch((error) => {
          AlertComponent("Error", error.message ?? "Something went wrong. Profile could not be loaded. Code: 5", { icon: `error` });
        })
        .finally(() => {
          dispatch({ type: "SET_LOADING", payload: false });
        });

      let filters = "offset=0&orderBy=name";
      axios
        .get(config.API_HM + "/subscriptions/members?" + filters)
        .then((result) => {
          if (result.data.total) {
            setAllMembersOptions(result.data.records);
          }
        })
        .catch(function (error) {
          return AlertComponent("Error", error?.Message, { icon: `error` });
        });
    }
  }, [state?.isLogged]);

  const handleSelectedMembers = (id) => {
    const members = {
      userId: id.value,
      permission: selectedPermission.value,
      permissionSelected: selectedPermission,
    };

    const memberFromList = allMembersOptions.filter((x) => x.userId === id.value);
    members.name = memberFromList.at(0)?.name;

    setSelectedMembers((prevItems) => [...prevItems, members]);

    setMembersOptions([]);
    setSelectedUser(null);
  };

  const removeUser = (indexToRemove) => {
    const newSelectedMembers = [...selectedMembers];
    newSelectedMembers.splice(indexToRemove, 1);
    setSelectedMembers(newSelectedMembers);
  };

  const possibleColorOptions = [
    { value: "#8C6584", label: "Chinese Violet" },
    { value: "#3E90F0", label: "Dodger blue" },
    { value: "#D84C10", label: "Golden Gate Bridge" },
    { value: "#8E55EA", label: "Veronica" },
    { value: "#7ECE18", label: "Sugus green" },
  ];

  const submit = async () => {
    if (!chatName) {
      return AlertComponent("Error", "Chat list name is required", { icon: `error` });
    }

    if (!selectedColor) {
      return AlertComponent("Error", "Color is required", { icon: `error` });
    }

    const correctMembers = selectedMembers.map((item) => {
      const { permissionSelected, name, ...rest } = item;
      return rest;
    });

    const payload = {
      name: chatName,
      color: selectedColor,
      members: correctMembers,
    };

    if (props.currentChatId > 0) {
      payload.id = props.currentChatId;
      await axios
        .put(config.API_HM + "/chatlists/"+payload.id, payload)
        .then(() => {
          setChatName(null);
          setSelectedColor(null);
          props.setShowCreateChat(false);
          if (props.afterCreateChat) {
            props.afterCreateChat();
          }
        })
        .catch(function (error) {
          return AlertComponent("Error", error?.response?.data?.message || error?.message, { icon: `error` });
        });
    } else {
      await axios
        .post(config.API_HM + "/chatlists", payload)
        .then((a) => {
          setChatName(null);
          setSelectedColor(null);
          props.setShowCreateChat(false);
          if (props.afterCreateChat) {
            props.afterCreateChat();
          }
        })
        .catch(function (error) {
          return AlertComponent("Error", error?.response?.data?.message || error?.message, { icon: `error` });
        });
    }
  };

  const loadMembersOptions = (value) => {
    if (value) {
      const existingMembers = selectedMembers.map((x) => {
        return x.userId;
      });

      setMembersOptions(
        allMembersOptions
          .filter((x) => x.email.includes(value) && !existingMembers.includes(x.userId))
          .map((x) => {
            return { value: x.userId, label: x.name + " (" + x.email + ")" };
          })
      );
    } else {
      setMembersOptions([]);
    }
  };

  const options = [
    { value: "Editor", label: "Full Access" },
    { value: "Reader", label: "Can View" },
  ];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "none",
      boxShadow: "none",
      backgroundColor: "transparent",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      display: "none", // Hide the caret / arrow
    }),
    menu: (provided) => {
      return {
        ...provided,
        display: membersOptions.length > 0 ? "block" : "none", // Hide the menu when there's no valid option
      };
    },
    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none", // Hide the divider
    }),
  };

  const customStylesOpt = {
    control: (provided) => ({
      ...provided,
      border: "none",
      boxShadow: "none",
      backgroundColor: "transparent",
    }),
  };

  const customStylesColors = {
    control: (provided) => ({
      ...provided,
      border: "none",
      boxShadow: "none",
      borderRadius: "20px",
      innerWidth: "145px",
      outerWidth: "145px",
      width: "145px",
      backgroundColor: "transparent",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      display: "none", // Hide the caret / arrow
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none", // Hide the divider
    }),
  };

  const handleChangeExistingUser = (item, index) => {
    const oldValue = selectedMembers[index];
    oldValue.permissionSelected = item;
    oldValue.permission = item.value;

    const newValues = [...selectedMembers];
    newValues.splice(index, 1);
    newValues.splice(index, 0, oldValue);
    setSelectedMembers(newValues);
  };

  const content = (
    <div className="newchatlist-container">
      <div className="newchatlist-content">
        <h4 className="text-center">Add chat list</h4>
        <div className="newchatlist-row">
          <div className="newchatlist-column">
            <FieldText
              label="Chat List Name"
              type="text"
              onChange={(x) => setChatName(x.target.value)}
              placeholder="Chat List Name"
              value={chatName}
              required={true}
              inputClassName={`newchatlist-name-input`}
              classNames="newchatlist-name"
            />
          </div>
          <div className="newchatlist-column newchatlist-select-color">
            <div className="form-group ">
              <label for="color">Select Color</label>
              <div className="input-container newcharlist-select-color-container">
                <div className="icon-container">
                  <FontAwesomeIcon style={{ color: colorOptionId?.value ?? "transparent", fontSize: "0.75em" }} icon={faSquare} />
                </div>
                <FieldSelect
                  customStyles={customStylesColors}
                  inputClassName="newcharlist-select-color"
                  options={possibleColorOptions}
                  id={`color`}
                  name={`color`}
                  onChange={setColorOption}
                  value={colorOptionId}
                  placeholder={`Choose a color`}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="newchatlist-row">
          <div className="newchatlist-column">
            <h5>Invite team member</h5>
          </div>
        </div>
        <div className="newchatlist-column newcharlist-panel">
          <div className="newchatlist-row">
            <div>
              <div className="input-container">
                <div className="icon-container">
                  <FontAwesomeIcon style={{ color: "#000000", fontSize: "1.25em" }} icon={faEnvelope} />
                </div>
                <FieldSelect
                  customStyles={customStyles}
                  options={membersOptions}
                  id={`memberId`}
                  name={`memberId`}
                  onChange={handleSelectedMembers}
                  placeholder={`Type the email`}
                  loadOptions={loadMembersOptions}
                  classNames="select-container-mail"
                  setFormControlSelect={false}
                  value={selectedUser}
                  components={{
                    NoOptionsMessage: () => {
                      return null;
                    },
                  }}
                />
                <div className="select-container">
                  <FieldSelect options={options} customStyles={customStylesOpt} setFormControlSelect={false} onChange={setSelectedPermission} value={selectedPermission} />
                </div>
              </div>
            </div>
          </div>
          <small className="text-muted">Only people invited in this list can access</small>
          <div className="newchatlist-column" style={{ marginTop: "20px" }}>
            {selectedMembers.map((x, index) => {
              return (
                <div className="newchatlist-row" key={`newchatlist_key_${index}`} style={{ alignItems: "center", marginBottom: "20px" }}>
                  <Image src={UserAvatar} width={40} height={40} radius={20} />
                  <div className="newchatlist-row newchatlist-card">
                    <span> {x.name}</span>

                    <div className="newcharlist-options">
                      <FieldSelect
                        options={options}
                        customStyles={customStylesOpt}
                        setFormControlSelect={false}
                        value={selectedMembers[index].permissionSelected}
                        onChange={(selected) => handleChangeExistingUser(selected, index)}
                        readonly={x.permission === "Creator"}
                      />
                      {x.permission !== "Creator" && <div className="newcharlist-user-remove" onClick={() => removeUser(index)}></div>}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="newchatlist-row newchatlist-button">
          <Button className="dark-btn add-list-btn" onClick={submit}>
            {props.currentChatId > 0 ? `Update List` : `Add List`}
          </Button>

          {props.setShowCreateChat && (
            <Button className="dark-btn cancel-btn" variant="light" onClick={props.setShowCreateChat}>
              Cancel
            </Button>
          )}
        </div>
      </div>
    </div>
  );

  const closeContainerStyle = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    width: 40,
    height: 40,
    backgroundColor: "#F3F5F7",
    position: "absolute",
    marginTop: 20,
    marginRight: -520,
    borderRadius: 40,
  };

  return (
    <ModalComponent
      className="modal-container"
      data={content}
      styleCloseContainer={closeContainerStyle}
      modalIsOpen={props.showCreateChat}
      setModalIsOpen={props.setShowCreateChat}
      showCloseText={false}
    />
  );
}

export default NewChatlist;
